import ApplySuccess from '@/assets/icons/ApplySuccess.svg';
import UKDialog from '@/components/UKDialog';
import { useTranslation } from '@/i18n/client';
import { DialogContent, DialogTitle } from '@mui/material';
import { observer } from 'mobx-react';
import CommonButton from '../commonButton';
import styles from './index.module.scss';

interface applySuccessModalProps {
  isOpen: boolean;
  closeHandler: () => void;
  viewDetailHandler: () => void;
}

const applySuccessModal: React.FC<applySuccessModalProps> = observer(
  ({ isOpen, closeHandler, viewDetailHandler }) => {
    const { t } = useTranslation();

    // 跳转首页
    const jumpToHome = () => {
      window.location.href = '/';
    };

    return (
      <UKDialog
        open={isOpen}
        onClose={closeHandler}
        sx={{
          '& .MuiDialog-paper': {
            width: '520px', // 设置自定义宽度
          },
        }}
      >
        <DialogTitle>
          <div className={styles.apply_success_modal_title}>
            <ApplySuccess className={styles.apply_success_icon} />
            {t('order.orderDetail.applySuccessModal.modalTitle')}
          </div>
        </DialogTitle>
        <DialogContent>
          <div className={styles.apply_success_content}>
            {t('order.orderDetail.applySuccessModal.modalContent')}
          </div>
          <div className={styles.oper_wrap}>
            <CommonButton
              variant='outlined'
              onClick={jumpToHome}
              style={{
                marginRight: '12px',
              }}
            >
              {t('order.orderDetail.applySuccessModal.shoppingBtn')}
            </CommonButton>
            <CommonButton variant='contained' onClick={viewDetailHandler} sx={{ boxShadow: 'none' }}>
              {t('order.orderDetail.applySuccessModal.detailBtn')}
            </CommonButton>
          </div>
        </DialogContent>
      </UKDialog>
    );
  },
);

export default applySuccessModal;
